export default [
    {
        field: 'hr_prevision_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Previsión',
        },
        options: {
            data: [],
            text: 'name',
            value: 'id',
        },
        rules: ['required'],
        value: '',
    },
    {
        field: 'hr_health_affiliation_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Afiliación de salud',
        },
        options: {
            data: [],
            text: 'name',
            value: 'id',
        },
        rules: ['required'],
        value: '',
    },
    {
        field: 'hr_isapre_type_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'ISAPRE',
        },
        options: {
            data: [],
            text: 'type',
            value: 'id',
        },
        rules: ['required'],
        value: '',
    },
    {
        field: 'contract_number',
        type: 'text',
        maxLength: 20,
        vuetifyProps: {
            outline: true,
            label: 'N°Contrato Isapre',
        },
        rules: ['required', 'numeric'],
        value: '',
    },
    {
        field: 'hr_previred_currency_id',
        type: 'select',
        maxLength: 10,
        vuetifyProps: {
            outline: true,
            label: 'Unidad Plan',
        },
        options: [{ text: 'CLP', value: 1 }, { text: 'UF', value: 2 }],
        rules: ['required'],
        value: '',
    },
    {
        field: 'uf_amount',
        type: 'float',
        maxLength: 10,
        vuetifyProps: {
            label: 'Monto Plan',
        },
        rules: ['required', 'numeric'],
        value: '',
    },
]
